module.exports = __webpack_public_path__ + "img/image_middle_lose_wifi_d@2x.73e2c344.png";